<template>
  <div class="exchange-dashboard">
    <div class="mb-8">
      <h2 class="text-2xl font-bold text-gray-900 mb-2">Exchange Rate Charts</h2>
      <p class="text-gray-600">
        Monitor Czech Koruna exchange rates across different time periods
      </p>
    </div>

    <!-- Currency Charts Grid -->
    <div class="grid grid-cols-1 gap-6">
      <CurrencyChart
        v-for="pair in store.currencyPairs"
        :key="pair.id"
        :currency-pair="pair"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useExchangeRateStore } from '@/stores/exchangeRateStore'
import CurrencyChart from '@/components/CurrencyChart.vue'

const store = useExchangeRateStore()
</script>

<style scoped>
.exchange-dashboard {
  max-width: 1400px;
  margin: 0 auto;
}
</style>
